<!--添加和编辑收货地址--><!--注意 theorder/order 中也有一份 添加与编辑 收货地址-->
<template>
    <div class="addressPopup">
        <div class="joinAddress-box">
				<div class="joinaddress-content-box">
					<div class="joinaddress-top">
						<p v-if="addresstype == 1">添加收货地址</p><p v-else-if="addresstype == 2">编辑收货地址</p>
						<p @click="closeaddress(bol)">×</p>
					</div>
					<div class="receipt-box dis-between">
                        <div style="width:33%">
                            <div class="receipt-username">
                                <span>*</span>收货人
                            </div>
                            <div class="receipt-user-input">
                                <input type="text" v-model="username" />
                            </div>
                            <div class="receipt-username">
                                <span>*</span>手机号码
                            </div>
                            <div class="receipt-user-input">
                                <input type="text" v-model="userphone" maxlength="11" min="0" onkeyup="value=value.replace(/[^0-9]/g,'')" />
                            </div>
                            <div class="receipt-username">
                                <span>*</span>地点名称 (地图选点)
                            </div>
                            <div class="receipt-user-input">
                                <input type="text" v-model="LngLatName" disabled />
                            </div>
                            <div class="receipt-username">
                                <span>*</span>详细地址 (可补充门牌号)
                            </div>
                            <div class="receipt-textarea-input">
                                <textarea rows="4" cols="20" style="outline:none;padding:10px 10px;width:18.625rem;color:#404040;" v-model="detailaddress"></textarea>
                            </div>
                            <div style="color:#929292;font-size:12px;width:305px">Ps: 地图选位置前，可用搜索功能定位到想要选点的城市区域，再通过鼠标 (放大、缩小、移动) 地图选取位置后，在关联的列表中点击选择目标地址</div>
                            
                            <div style="width:300px;border-top:1px solid #999999;margin-top:20px"></div>
                            <div class="dis-between" style="width:300px">
                                <div class="receipt-username" style="margin:auto 30px auto 0">
                                    <span>*</span>性别
                                </div>
                                <div style="margin:10px 0">
                                    <input type="radio" v-model="sexValue" value="1"><span style="margin:0 20px 0 10px">男</span>
                                    <input type="radio" v-model="sexValue" value="2"><span style="margin:0 0 0 10px">女</span>
                                </div>
                            </div>
                            <div class="dis-between" style="width:300px">
                                <div class="receipt-username" style="margin:auto 30px auto 0">
                                    <span>*</span>区域类型
                                </div>
                                <div style="margin:10px 0">
                                    <input type="radio" v-model="cityTypeValue" value="1"><span style="margin:0 20px 0 10px">城市</span>
                                    <input type="radio" v-model="cityTypeValue" value="2"><span style="margin:0 0 0 10px">非城市</span>
                                </div>
                            </div>
                            <div class="dis-between" style="width:300px">
                                <div class="receipt-username" style="margin:auto 30px auto 0">
                                    是否默认
                                </div>
                                <div style="margin:10px 0">
                                    <div v-if="!isDefaultValue" class="dis" @click="buttonClick" style="width:40px;height:20px;border-radius:30px;background-color:#f1f1f1;border:1px solid #f1f1f1">
                                        <div style="width:16px;height:16px;border-radius:50px;background-color:#929292;margin:1px 0 0 1px"></div>
                                    </div>
                                    <div v-else class="dis" @click="buttonClick" style="width:40px;height:20px;border-radius:30px;background-color:#0075ff;border:1px solid #f1f1f1">
                                        <div style="width:16px;height:16px;border-radius:50px;background-color:#ffffff;margin:1px 0 0 21px"></div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="saveAddress" style="margin: 30px 0 0 0" @click="saveAddress">保存收货地址</div>
                        </div>
                        <div style="width:67%;height:620px;margin:0 20px 0 20px">
                            <iframe id="mapPage" width="100%" height="100%" frameborder=0
                                src="https://apis.map.qq.com/tools/locpicker?search=1&center=29.076821,119.645257&type=1&key=E25BZ-BENKD-2UZ4S-HXOGB-SKWI3-NFBED&referer=myapp">
                            </iframe>
                        </div>
                    </div>
				</div>
			</div>
    </div>
</template>

<script>
    export default
    {
        name: 'addressPopup',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                addresstype: 1,
                username: "", //收货人
                userphone: "", //手机号
                detailaddress: "", //详细地址
                LngLatName: '',
                Address: '',
                LngLat: '',
                sexValue: '',
                cityTypeValue: '',
                isDefaultValue: false,
                latlngObj: {},
                lat_province_id: "",
                lat_city_id: "",
                lat_area_id: "",
                // +--------------------------------------------------------
                bol: false,
            };
        },

        created()
        {
            if (this.parentName.id) {
                let objAddress = this.parentName
                let laglngStr = objAddress.lngLat.split(',')

                this.addresstype = 2
                this.addressId = objAddress.id //地址id
                this.userphone = objAddress.phone
                this.username = objAddress.userName
                this.detailaddress = objAddress.address
                this.lat_province_id = objAddress.province
                this.lat_city_id  = objAddress.city
                this.lat_area_id  = objAddress.region
                this.LngLatName  = objAddress.lngLatAddress
                this.detailaddress = objAddress.address
                this.LngLat = objAddress.lngLat
                this.sexValue = objAddress.sex
                this.cityTypeValue = objAddress.type == 0?1:2   // type 0 城市 1非城市
                this.isDefaultValue = objAddress.isDefault
                this.latlngObj = {lat:laglngStr[1], lng:laglngStr[0]}
            }
        },
        mounted() {
            let that = this
            window.addEventListener('message', function(event) {
                // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
                var loc = event.data
                if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                    that.LngLatName = loc.poiname
                    that.detailaddress = loc.poiaddress
                    that.latlngObj = loc.latlng
                    that.LngLat = loc.latlng.lng + ',' + loc.latlng.lat
                }
            }, false)
        },
        methods:
        {
            buttonClick() {
                this.isDefaultValue = !this.isDefaultValue
            },
            saveAddress() {
                let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/
                if (this.username == "") {
                    let name = "收货人不能为空!"
                    this.checkTips(name, "warning")
                } else if (!this.sexValue) {
                    this.checkTips("请选择性别", "warning")
                } else if (!this.cityTypeValue) {
                    this.checkTips("请选择区域类型", "warning")
                } else if (!this.LngLatName) {
                    this.checkTips("请先地图选点", "warning")
                } else if (this.detailaddress == "") {
                    let name = "详细地址不能为空!"
                    this.checkTips(name, "warning")
                } else if (this.userphone == "") {
                    let name = "手机号不能为空!"
                    this.checkTips(name, "warning")
                } else if (!telReg.test(this.userphone)) {
                    let name = "手机号格式错误!"
                    this.checkTips(name, "warning")
                } else {
                    // 经纬度换地址
                    let url = 'https://apis.map.qq.com/ws/geocoder/v1/?location=' +this.latlngObj.lat + ',' + this.latlngObj.lng + '&key=E25BZ-BENKD-2UZ4S-HXOGB-SKWI3-NFBED&get_poi=1'
                    this.$jsonp(url, {
                        output: "jsonp"
                    }).then(res => {
                        // 换城市的ID
                        let dataObj = res.result.address_component
                        let inputData2 = {"ProvinceName":dataObj.province,"CityName":dataObj.city,"RegionName":dataObj.district}
                        this.$loading()
                        this.$api.order.GetRegionIdByCityName(inputData2).then(res => {
                            this.$loading().close()
                            if (res.data.code == 0) {
                                let v_obj = res.data.result
                                this.lat_province_id = v_obj.provinceId
                                this.lat_city_id = v_obj.cityId
                                this.lat_area_id =v_obj.regionId
                                this.baocunFn()
                            } else {
                                let name = res.data.message
                                this.checkTips(name, "error")
                            }
                        })
                    }).catch(err => {
                        this.$loading().close()
                        alert(err)
                    })
                }
            },
            baocunFn() {
                this.$loading()
                if (this.addresstype == 1) {
                    let params = {
                        Name:this.username,
                        Phone:this.userphone,
                        Province: this.lat_province_id,
                        City: this.lat_city_id,
                        Region: this.lat_area_id,
                        LngLatAddress:this.LngLatName,
                        Address:this.detailaddress,
                        LngLat:this.LngLat,
                        Sex: Number(this.sexValue),
                        type: Number(this.cityTypeValue) == 1?0:1,
                        IsDefault:this.isDefaultValue?true:false
                    }
                    this.$api.order.joinAddress(params).then(res => {
                        this.$loading().close()
                        if (res.data.code == 0) {
                            let name = "添加成功!"
                            this.checkTips(name, "success")
                            this.closeaddress(this.bol)
                        } else {
                            let name = res.data.message
                            this.checkTips(name, "error")
                        }
                    })
                } else {
                    let params = {
                        id: this.addressId,
                        Name:this.username,
                        Phone:this.userphone,
                        Province: this.lat_province_id,
                        City: this.lat_city_id,
                        Region: this.lat_area_id,
                        LngLatAddress:this.LngLatName,
                        Address:this.detailaddress,
                        LngLat:this.LngLat,
                        Sex: Number(this.sexValue),
                        type: Number(this.cityTypeValue) == 1?0:1,
                        IsDefault:this.isDefaultValue?true:false
                    }
                    this.$api.order.editAddress(params).then(res => {
                        this.$loading().close()
                        if (res.data.code == 0) {
                            let name = "修改成功!"
                            this.checkTips(name, "success")
                            this.closeaddress(this.bol)
                        } else {
                            let name = res.data.message
                            this.checkTips(name, "error")
                        }
                    })
                }
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
            // +--------------------------------------
            closeaddress(val)
            {
                this.$emit( 'childFn', val )
            }
        }
    }
</script>
<style scoped>
.list-page >>> .el-pagination .btn-prev {
    margin-right:5px
}
.or-new-input >>> .el-input__inner{
    height:35px;
    line-height: 35px
}
.or-new-input >>> .el-input__icon {
    line-height: 35px
}
.orderpay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
}

.paysuccess {
    width: 9.375rem;
    height: 1.875rem;
    border-radius: 5px;
    text-align: center;
    font-size: 0.875rem;
    font-weight: 400;
    color: #ffffff;
    background-color: #37a115;
    margin: 1.25rem auto 0 auto;
    line-height: 1.875rem;
    cursor: pointer;
}

.success-btn {
    width: 9.375rem;
    height: 1.875rem;
    text-align: center;
    line-height: 1.875rem;
    margin: 1.25rem auto 0 auto;
    background-color: #37a115;
    color: #ffffff;
    font-size: 14px;
    border-radius: 0.3125rem;
    cursor: pointer;
}

.soon-pay-btn {
    width: 13.0625rem;
    height: 3.125rem;
    text-align: center;
    line-height: 3.125rem;
    color: #ffffff;
    font-size: 18px;
    background-color: #d43737;
    margin-left: 2.6875rem;
    margin-top: 2.5rem;
    cursor: pointer;
}

.submit-box {
    width: 65.625rem;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 3.125rem;
}

.pay-code {
    width: 9.375rem;
    height: 9.375rem;
    /* border: 1px solid #FF0000; */
    /* border-radius: 10px; */
    margin: 1.5rem auto 0 auto;
    overflow: hidden;
}

.paytype-item img:nth-of-type(1) {
    width: 5.75rem;
    margin-right: 1rem;
}

.paytype-item img:nth-of-type(2) {
    width: 3.4375rem;
    margin-right: 1rem;
}

.paytype-item img:nth-of-type(3) {
    width: 3.5625rem;
}

.paytype-item img {
    height: 1.125rem;
}

.paytype-item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.875rem;
}

.pay-code-tips {
    margin-top: 1.875rem;
    color: #191919;
    font-size: 17px;
    text-align: center;
}

.pay-code-price span {
    color: #37a115;
    font-weight: bold;
    font-size: 2.125rem;
}

.pay-code-price {
    font-size: 24px;
    color: #191919;
    margin-top: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pay-code-top p:nth-of-type(2) {
    font-size: 28px;
    cursor: pointer;
}

.pay-code-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #191919;
    font-size: 1rem;
}

.pay-code-content {
    width: 29.375rem;
    height: 27.5rem;
    background-color: #ffffff;
    border-radius: 0.625rem;
    border: 4px solid #b3b3b3;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 0.4375rem;
}

.pay-code-box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.1);
    z-index: 10;
}

.pay-type-imgbox {
    margin-top: 15px;
}

.pay-type-imgbox img:nth-of-type(2) {
    margin: 0 1.25rem 0 1.25rem;
}

.pay-type-imgbox {
    display: flex;
    justify-content: center;
    align-items: center;
}

.pay-right-box p {
    color: #676767;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
}

.pay-right-box {
    margin-left: 6.25rem;
}

.pay-type-box {
    display: flex;
    height: auto;
}

.receipt-address-input {
    width: 28rem;
    height: 2rem;
    color: #404040;
    display: flex;
    /* //  justify-content: space-between; */
    margin-bottom: 0.875rem;
}

.receipt-address-input>>>.el-input__icon {
    line-height: 2rem
}

.saveAddress {
    width: 7.125rem;
    height: 1.875rem;
    text-align: center;
    line-height: 1.75rem;
    border: 1px solid #cccccc;
    border-radius: 5px;
    background-color: #f5f5f5;
    color: #737373;
    font-size: 0.75rem;
    cursor: pointer;
}

.receipt-user-input {
    margin-bottom: 0.875rem;
}

input {
    -moz-appearance: none !important;
    outline: none !important;
    -moz-outline: none !important;
    padding-left: 0.625rem;
}

.receipt-user-input,
.receipt-user-input input {
    width: 18.625rem;
    height: 2rem;
    outline: none;
    box-shadow: none;
    color: #404040;
}

.receipt-textarea-input {
    margin-bottom: 0.875rem;
}

.receipt-textarea-input input {
    width: 14.625rem;
    height: 5rem;
    outline: none;
    box-shadow: none;
    color: #404040;
}

.receipt-username span {
    color: #cb0000;
    display: inline-block;
    margin-right: 0.3125rem;
}

.receipt-username {
    font-size: 12px;
    color: #404040;
    font-weight: 400;
    margin-bottom: 0.5rem;
}

.receipt-box {
    padding-left: 1.75rem;
}

.joinaddress-top p:nth-of-type(2) {
    font-size: 25px;
    cursor: pointer;
}

.joinaddress-top {
    font-size: #191919;
    font-size: 1rem;
    font-weight: 400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.375rem 1.6875rem 0 0.5rem;
    margin-bottom: 1.875rem;
}

.joinaddress-content-box {
    width: 75.125rem;
    height: 45.125rem;
    background-color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.625rem;
    border: 7px solid #b3b3b3;
}

.joinAddress-box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.1);
    z-index: 10;
}

.foods-buybtn {
    width: 5.4375rem;
    height: 1.875rem;
    text-align: center;
    line-height: 28px;
    color: #333333;
    font-size: 14px;
    border: 1px solid #dddddd;
    border-radius: 2px;
    background-color: #dddddd;
    margin-left: 1.25rem;
    cursor: pointer;
    margin-top: 3.125rem;
}

.myorder-child-flag {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 6.25rem;
    text-align: center;
}

.child-allprice {
    color: #999999;
    font-size: 12px;
    font-weight: 400;
}

.child-discount {
    color: #cb0000;
    font-size: 14px;
    font-weight: bold;
}

.myorder-child-price {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.myorder-child-name img {
    margin-left: 4px;
}

.myorder-child-flag {
    width: 5.625rem;
    height: 6.25rem;
    border-right: 1px solid #ededed;
}

.myorder-child-price {
    width: 7.5rem;
    height: 6.25rem;
    border-right: 1px solid #ededed;
}

.myorder-child-name {
    width: 7.25rem;
    height: 6.25rem;
    border-right: 1px solid #ededed;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-size: 14px;
}

.foods-buynum {
    color: #333333;
    font-size: 14px;
    margin-left: 1.25rem;
}

.foods-allprice {
    color: #999999;
    text-decoration: line-through;
    font-size: 12px;
}

.foods-discount {
    color: #333333;
    font-size: 14px;
}

.foods-price-box {
    width: 12.5rem;
    text-align: center;
    font-weight: 400;
}

.foods-name {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    margin-left: 1.25rem;
}

.myorder-child-item img {
    width: 5.3125rem;
    height: 4.6875rem;
    margin-left: 1.25rem;
}

.myorder-child-item {
    width: 28.5rem;
    display: flex;
    align-items: center;
    height: 6.25rem;
    border-right: 1px solid #ededed;
    padding-right: 1.25rem;
}

.myorder-child-box {
    width: 100%;
    height: auto;
    min-height: 6.625rem;
    display: flex;
    align-items: center;
}

.myorder-orderIndex span {
    color: #343434;
    font-weight: 400;
}

.myorder-orderIndex {
    margin-left: 1.875rem;
}

.myorder-buytime {
    margin-left: 1rem;
}

.myorder-items-tops {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #9a9a9a;
}

.myorder-items {
    width: 100%;
    height: auto;
    min-height: 9.125rem;
    background-color: #ffffff;
    margin-top: 1.125rem;
    padding-left: 13px;
    padding-top: 9px;
    display: flex;
    align-items: flex-start;
}

.order-allprice,
.order-flag,
.order-cz {
    margin-left: 4.375rem;
}

.order-address {
    margin-left: 11.25rem;
}

.order-detailinfo {
    margin-left: 8.125rem;
}

.myorder-header-box {
    width: 100%;
    height: 2.1875rem;
    background-color: #ffffff;
    padding-left: 1.25rem;
    display: flex;
    align-items: center;
    color: #666666;
    font-size: 12px;
}

.deal-bigbox {
    width: 100%;
    height: auto;
    background-color: #f3f3f3;
    padding: 0 1px 1px 1px;
}

.deal-order-item>div {
    height: 3.125rem;
    line-height: 3.125rem;
}

.deal-order-price {
    width: 9.875rem;
    color: #c10000;
    font-size: 16px;
}

.deal-order-text {
    width: 23.75rem;
    border-right: 1px dashed #e3e3e3;
}

.deal-order-type {
    width: 9.5625rem;
    border-right: 1px dashed #e3e3e3;
}

.deal-order-day {
    color: #999999;
    font-size: 12px;
    margin-top: 0.5rem;
}

.deal-order-year {
    margin-top: 0.625rem;
}

.deal-order-time {
    width: 9.8rem;
    border-right: 1px dashed #e3e3e3;
    line-height: 12px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.deal-order-item {
    width: 100%;
    height: 5.25rem;
    background-color: #ffffff;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    font-size: 14px;
    color: #333333;
    text-align: center;
    font-weight: 400;
    margin-bottom: 0.5rem;
}

.deal-order-num span {
    color: #069338;
}

.deal-order-num {
    display: flex;
    align-items: center;
    margin-left: 2.5rem;
}

.deal-order-left {
    color: #666666;
    font-size: 12px;
}

.deal-order-left {
    display: flex;
    align-items: center;
}

.deal-order-box {
    height: 2.25rem;
    background-color: #f3f3f3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #666666;
    font-size: 12px;
    padding-left: 1rem;
    padding-right: 1rem;
}

.deal-order-left .el-checkbox__inner {
    width: 14px;
    height: 14px;
}

.deal-top-money {
    width: 9.875rem;
    text-align: center;
}

.deal-top-summary {
    width: 24rem;
    border-right: 1px solid #cecece;
    text-align: center;
}

.deal-top-type {
    text-align: center;
}

.deal-top-type {
    width: 9.625rem;
    border-right: 1px solid #cecece;
}

.deal-top-time {
    width: 6.6875rem;
    border-right: 1px solid #cecece;
}

.deal-top-box {
    width: 100%;
    height: 3.5rem;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    padding: 0 3.125rem;
    border: 1px solid #f3f3f3;
}

.found-time-box {
    /* width: 16.875rem; */
    height: 2.1875rem;
}

.deal-found-btn {
    width: 6.5rem;
    height: 2.1875rem;
    background-color: #37a115;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    line-height: 2.1875rem;
    margin-left: 0.625rem;
    cursor: pointer;
}

.deal-found-type {
    width: 6.75rem;
    height: 2.1875rem;
    margin-right: 0.625rem;
}

.transaction-record-title {
    width: 6.75rem;
    height: 2.0625rem;
    line-height: 2.0625rem;
    text-align: center;
    background-color: #ffffff;
    position: absolute;
    top: -1.0313rem;
    left: 1.875rem;
    color: #333333;
    font-size: 16px;
}

.transaction-tips {
    /* width: 53.5rem; */
    width: 100%;
    height: 4.25rem;
    border: 1px solid #ebebeb;
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 1.875rem;
    margin-bottom: 1rem;
}

.buyrecord-showbox {
    padding: 2.5rem 0.5625rem 1rem 0.75rem;
}

.operating-cancel {
    width: 5.9375rem;
    color: #666666;
    font-size: 12px;
    margin-top: 0.625rem;
    text-align: center;
    cursor: pointer;
}

.operating-joincart {
    width: 5.9375rem;
    height: 1.625rem;
    text-align: center;
    line-height: 1.625rem;
    background-color: #37a115;
    color: #ffffff;
    font-size: 12px;
    border-radius: 5px;
    cursor: pointer;
}

.mysaveprice-all {
    color: #999999;
    font-size: 12px;
    text-decoration: line-through;
    /* margin-top: 4px; */
}

.mysaveprice-discount {
    color: #cb0000;
    font-size: 14px;
    font-weight: bold;
}

.mysave-shop-price {
    text-align: center;
}

.mysave-input input:disabled {
    background-color: #ffffff;
}

.mysave-input input {
    border: 1px solid #cfcfcf;
    outline: none;
}

.mysave-input {
    margin: 0 5px;
}

.mysave-input,
.mysave-input input {
    width: 2.25rem;
    height: 1.3125rem;
    text-align: center;
    color: #333333;
    font-size: 16px;
}

.mysave-less,
.mysave-add {
    width: 1.3125rem;
    height: 1.3125rem;
    border-radius: 50%;
    border: 1px solid #cfcfcf;
    text-align: center;
    line-height: 1.1rem;
    color: #333333;
    font-size: 16px;
    cursor: pointer;
}

.mysave-operating {
    width: 11.0625rem;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    /* flex-wrap: wrap; */
    flex-direction: column;
}

.mysave-shop-price {
    width: 8rem;
}

.mysave-num {
    width: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.show-shop-box p {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
}

.show-shop-box img {
    width: 5.3125rem;
    height: 4.6875rem;
}

.show-shop-box {
    width: 19.375rem;
    display: flex;
    align-items: center;
    padding-left: 2.5rem;
    padding-right: 1.875rem;
    justify-content: space-between;
}

.save-line {
    width: 1px;
    height: 4.375rem;
    background-color: #ededed;
}

.mysave-index {
    /* width: 14px;
		height: 14px; */
    background: #f8f8f8;
    /* border: 1px solid #767676; */
    border-radius: 3px;
    margin-right: 1.25rem;
}

.mysave-item {
    width: 100%;
    height: 6.0625rem;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 3.125rem 0 1.75rem;
    margin-bottom: 1.25rem;
}

.saveactice {
    background-color: #069338 !important;
    color: #ffffff !important;
}

.choose-allitem span i,
.mysave-index i {
    display: inline-block;
    width: 10px;
    height: 8px;
    border-top: 1px solid #ffffff;
    border-right: 1px solid #ffffff;
    transform: rotate(120deg);
    margin-bottom: 8px;
}

.choose-allitem span {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: #f8f8f8;
    border: 1px solid #767676;
    border-radius: 3px;
    margin-right: 5px;
    cursor: pointer;
    text-align: center;
    line-height: 14px;
}

.choose-allitem {
    display: flex;
    align-items: center;
}

.mysave-top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    height: 2.1875rem;
    padding: 0 6.25rem 0 1.875rem;
    color: #333333;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 1.25rem;
}

.buyrecord-showbox {
    width: 100%;
    min-height: 38.375rem;
    background-color: #ffffff;
}

.paybtn {
    width: 12.5rem;
    height: 2.75rem;
    background-color: #37a115;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    line-height: 2.75rem;
    margin-top: 4.375rem;
    cursor: pointer;
}

.paytype_img {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 9px;
    height: 9px;
    z-index: 10;
}

.paytype_bg {
    width: 0;
    height: 0;
    border-left: 25px solid transparent;
    border-top: 23px solid #37a115;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9;
}

.zfbpay {
    background: url(../../../assets/image/img/详情页/zfb_pay.png);
}

.wxpay {
    background: url(../../../assets/image/img/详情页/wx_pay.png);
}

.nypay {
    background: url(../../../assets/image/img/详情页/ny_bank.png);
}

.gspay {
    background: url(../../../assets/image/img/详情页/gs_bank.png);
}

.pay-type-item {
    width: 8.75rem;
    height: 3.125rem;
    margin-right: 2.375rem;
    cursor: pointer;
    position: relative;
}

.pay-type-item-box {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
}

.pay-type-tips {
    color: #676767;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 1.25rem;
}

.chooseMoney {
    border-color: #37a115 !important;
}

.money_okimg {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 14px;
    height: 14px;
}

.choose_bg {
    width: 0;
    height: 0;
    border-top: 30px solid #37a115;
    border-left: 30px solid transparent;
    position: absolute;
    top: 0;
    right: 0;
}

.recharge-money-number input:disabled {
    background-color: #ffffff;
}

.recharge-money-number {
    border: 1px solid #cfcfcf;
    position: relative;
}

.recharge-money-number input {
    outline: none;
    width: 100%;
    height: 100%;
    border: none;
    text-align: center;
    cursor: pointer;
    color: #676767;
    font-size: 18px;
}

.recharge-money-number {
    width: 8rem;
    height: 3.125rem;
    border-radius: 0;
    margin-right: 1.25rem;
}

.recharge-money-box {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    margin-top: 1.625rem;
    margin-bottom: 1.875rem;
}

.recharge-money-tips {
    color: #676767;
    font-size: 14px;
    font-weight: 400;
}

.account-recharge {
    color: #676767;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 1.875rem;
}

.recharge-line {
    width: 100%;
    height: 1px;
    background-color: #cccccc;
    margin-bottom: 1.25rem;
}

.myMoney span {
    font-size: 24px;
    font-weight: 400;
}

.myMoney {
    font-size: 40px;
    font-weight: bold;
    color: #37a115;
    margin-top: 0.625rem;
    margin-bottom: 1.25rem;
}

.recharge-tip {
    color: #676767;
    font-size: 16px;
    font-weight: 400;
}

.online-Recharge-showbox {
    width: 100%;
    height: auto;
    min-height: 37.5rem;
    padding: 2.5rem 5.875rem 3.75rem 1.875rem;
    background-color: #ffffff;
}

.address_active {
    border-color: #bdd2c5 !important;
}

.delActive {
    background-color: #f7e4e4;
    color: #9f3737 !important;
    border-color: #cca6a6 !important;
}

.editActive {
    background-color: #d9ece0;
    border-color: #bdd2c5 !important;
}

.user-detail-address p {
    color: #333333;
}

.user-detail-address,
.user-detail-address p {
    font-size: 14px;
    font-weight: 400;
}

.user-detail-address {
    display: flex;
    align-items: center;
    color: #999999;
}

.address-line {
    width: 100%;
    height: 1px;
    background-color: #bfbfbf;
    opacity: 0.3;
    margin-top: 0.75rem;
    margin-bottom: 1.125rem;
}

.address-edit {
    margin-right: 5px;
}

.address-edit,
.address-del {
    width: 4.5rem;
    /* height: 2rem; */

    color: #333333;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    /* line-height: 2rem; */
    cursor: pointer;
}

.adddress-btn {
    display: flex;
    align-items: center;
}

.address-default {
    width: auto;
    height: auto;
    color: #333333;
    text-align: center;
    line-height: 1.375rem;
    font-size: 12px;
    /* border: 1px solid #bfbfbf; */
    cursor: pointer;
    /* margin-left: 1.25rem;
	padding: 1px 4px; */
}

.address-phone-box {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin-left: 0.9375rem;
}

.address-phone-box span {
    color: #333333;
}

.address-username {
    color: #333333;
    font-size: 18px;
    font-weight: 400;
}

.adddress-userInfo-box {
    display: flex;
    align-items: center;
}

.address-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.address-item {
    width: 44.375rem;
    height: 7.1875rem;
    border: 2px dashed #e9e9e9;
    margin-bottom: 1.5rem;
    padding: 0.875rem 1.625rem 1.25rem 1.25rem;
}

.shipping-address,
.add-adddress {
    color: #37a115;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.25rem;
    cursor: pointer;
}

.shipping-address {
    /* text-decoration: underline; */
    border-bottom: 1px solid #37a115;
}

.myInfo-top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;
}

.myInfo-showbox {
    width: 100%;
    height: 38.375rem;
    /* min-height: 38.375rem; */
    background-color: #ffffff;
    /* padding: 1.875rem 7.5rem 0 3rem; */
    padding: 0 13px;
    overflow: auto;
}

.nolock img {
    margin-right: 0.625rem;
}

.nolock {
    display: flex;
    align-items: center;
    justify-content: center;
}

.okimg {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 2;
}

.lock {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 2;
}

.account-imgs {
    width: 0;
    height: 0;
    border-top: 2.875rem solid #37a115;
    border-left: 2.5rem solid transparent;
    position: absolute;
    top: 0;
    right: 0;
}

.account-img {
    width: 0;
    height: 0;
    border-top: 2.875rem solid #b9b9b9;
    border-left: 2.5rem solid transparent;
    position: absolute;
    top: 0;
    right: 0;
}

.account-phone-ok {
    width: 12.5rem;
    height: 3rem;
    line-height: 3rem;
    margin: 1.125rem auto 0 auto;
    text-align: center;
    color: #333333;
    font-size: 16px;
    border: 1px solid #999999;
    cursor: pointer;
}

.account-phone-tips {
    color: #999999;
    font-size: 14px;
    margin-top: 0.9375rem;
}

.account-phone {
    color: #333333;
    font-size: 20px;
    margin-top: 1.25rem;
}

.account-item {
    width: 16.5rem;
    height: 100%;
    background-color: #ffffff;
    text-align: center;
    padding-top: 2.4375rem;
    margin-right: 3rem;
    position: relative;
}

.account-item-box {
    width: 100%;
    height: 18.75rem;
    margin-top: 1.25rem;
    display: flex;
}

.account-suggest {
    color: #eb8f05;
    margin-top: 0.625rem;
    font-size: 14px;
    font-weight: 400;
}

.account-steps span {
    color: #eb9000 !important;
}

.account-steps {
    color: #414141;
    font-size: 18px;
    font-weight: 400;
}

.account-top-tips {
    margin-left: 0.625rem;
}

.account-top-img,
.account-top-img img {
    width: 6.1875rem;
    height: 5.1875rem;
}

.account-top-box {
    width: 100%;
    height: 8.625rem;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding-left: 2.5rem;
}

.personal-center-detail {
    width: 57.4375rem;
}

.chooseActive {
    color: #37a115 !important;
}

.indexActive {
    background-color: #37a115 !important;
}

/* .order-big span {
	display: inline-block;
	width: 0.25rem;
	height: 0.25rem;
	border-radius: 50%;
	background-color: #d0d0d0;
	margin-right: 0.625rem;
} */

.mysave-box,
.myorder-box {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.mysave-box {
    height: 2.75rem;
    line-height: 2.75rem;
}

.myorder-box {
    width: 100%;
    /* height: 2.8125rem;
	line-height: 2.8125rem;
	border-bottom: 1px dashed #e7e7e7; */
}

.order-big {
    padding: 0 1.5625rem;
    color: #666666;
    font-size: 14px;
    font-weight: 400;
    /* height: 5.6875rem; */
    background-color: #ffffff;
}

.myorder-center {
    width: 100%;
    /* height: 2.5rem; */
    /* line-height: 34px; */
    margin: 17px 0;
    color: #333333;
    /* background-color: #f5f5f5; */
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    padding-left: 1.625rem;
}

.myfried-Anfu {
    width: 100%;
    height: 3.625rem;
    color: #333333;
    line-height: 3.625rem;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
}

.personal-center-navBox {
    width: 16.8125rem;
    height: 380px;
    background-color: #ffffff;
}

.personal-center-content {
    width: 75rem;
    height: auto;
    min-height: 43.75rem;
    margin: auto;
    display: flex;
    justify-content: space-between;
    padding-bottom: 2.5rem;
}

.personal-center-box {
    width: 100%;
    height: 100%;
    background-color: #f1f1f1;
    /* padding-top: 1.875rem; */
}

.mycart-no-tips {
    width: 75rem;
    margin: auto;
    /* padding-left: 1rem; */
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    line-height: 34px;
    padding: 0.3rem 0;
}
</style>